export enum UserRole {
  Administrator = 'administrator',
  Ekome_Publisher = 'ekome_publisher',
  Ekome_Editor = 'ekome_editor',
  Film_Office_Publisher = 'film_office_publisher',
  Film_Office_Editor = 'film_office_editor',
}

//new internal role 
export const dialOptions = [
  {
    key: '1',
    info: 'info',
    label: 'Διαλειτουργικότητες ΑΑΔΕ',
    checked: true
  },
  {
    key: '2',
    info: 'info',
    label: 'Διαλειτουργικότητες ΕΦΚΑ',
    checked: false
  },
  {
    key: '3',
    info: 'info',
    label: 'Διαλειτουργικότητες Τραπεζών',
    checked: false
  },
  {
    key: '4',
    info: 'info',
    label: 'Διαλειτουργικότητες ΗΔΙΚΑ',
    checked: false
  }
];

export const radioOptions = [
  { key: '1', label: 'Για την οργανική μονάδα (Film Office) που ανήκω' },
  { key: '2', label: 'Για όλες τις οργανικές μονάδες (Film Office)' }
];

export const requestOptions = [
  {
    key: '1',
    info: 'info',
    label: 'Υποβολή Αιτήματος Καταχώρισης Τοποθεσίας',
    radioValue: '1',
    checked: false
  },
  {
    key: '2',
    info: 'info',
    label: 'Υποβολή Αιτήματος Αλλαγής Στοιχείων Τοποθεσίας',
    radioValue: '1',
    checked: false
  },
  {
    key: '3',
    info: 'info',
    label: 'Υποβολή Αιτήματος Καταχώρισης Επαγγελματία',
    radioValue: '1',
    checked: false,
  },
  {
    key: '4',
    info: 'info',
    label: 'Υποβολή Αιτήματος Αλλαγής Στοιχείων Επαγγελματία',
    radioValue: '1',
    checked: false,
  },
];

export const options = [
  { key: '1', label: 'Email / Password' },
  { key: '2', label: 'Microsoft Account' }
];

//new external role 
export const signInOptions = [
  { key: '1', label: 'TaxisNet' },
  { key: '2', label: 'Facebook' },
  { key: '3', label: 'Google' },
];

export const favoritesOptions = [
  {
    key: '1',
    label: 'Προσθήκη / Αφαίρεση Τοποθεσίας σε Αγαπημένα',
    info: 'info',
    checked: false
  },
  {
    key: '2',
    label: 'Προσθήκη / Αφαίρεση Επαγγελματία σε Αγαπημένα',
    info: 'info',
    checked: false
  }
];

export const requestsOptions = [
  {
    key: '1',
    label: 'Αίτημα Καταχώρησης Τοποθεσίας (Ιδιοκτησίας)',
    info: 'info',
    checked: false
  },
  {
    key: '2',
    label: 'Αίτημα Καταχώρησης Επαγγελματία/Επιχείρησης',
    info: 'info',
    checked: false
  },
];

export const restRequests = [
  {
    key: '1',
    label: 'Αίτημα Ενδιαφέροντος για Γύρισμα σε Τοποθεσία',
    info: 'info',
    checked: false
  }
];
